import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MessageBubble from "./message_bubble";
import Utils from "../utils";

export default function DailyMessagesDrawer(props) {
    const messagesRef = useRef(null);          // the scrollable container (".messages")
    const keepPosRef = useRef({ pending: false, offsetFromBottom: 0 });

    const { showDailyMessage, messages, iconPath, toggleDailyMessage } = props;
    const [showMoreCount, setShowMoreCount] = useState(0);

    const className = showDailyMessage ? "open" : "";

    function showMore() {
        const el = messagesRef.current;
        if (!el) return;
        keepPosRef.current.pending = true;
        keepPosRef.current.offsetFromBottom = el.scrollHeight - el.scrollTop;
        setShowMoreCount((c) => c + 10);
    }

    const unreadMessages = messages.filter((message) => !message.read);
    const startIndex = Math.max(0, messages.length - showMoreCount - Math.max(unreadMessages.length, 1));
    const messagesToShow = messages.slice(startIndex, messages.length);

    useLayoutEffect(() => {
        if (!keepPosRef.current.pending) return;
        const el = messagesRef.current;
        if (!el) return;
        el.scrollTop = el.scrollHeight - keepPosRef.current.offsetFromBottom;
        keepPosRef.current.pending = false;
    }, [showMoreCount]);

    useLayoutEffect(() => {
        if (!messagesRef.current) return;
        if (keepPosRef.current.pending) return; // showMore will handle its own scroll fix
        if (showDailyMessage) {
            // Jump (or use behavior: 'smooth' if desired)
            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
            // Or: bottomRef.current?.scrollIntoView({ block: "end" });
        }
    }, [showDailyMessage, messages.length]);

    useEffect(() => {
        if (messagesRef.current) {
            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
        }
    }, []);

    return (
        <div id="daily-messages-drawer" className={"assistant-drawer " + className}>
            <div className="assistant-drawer-header">
                Mensaje diario
                <div className="assistant-drawer-close" onClick={toggleDailyMessage} onKeyPress={() => {}}>&times;</div>
            </div>
            <div ref={messagesRef} className="messages">
                {startIndex !== 0 && (<div className="show-more" onClick={showMore} onKeyPress={() => {}}>
                    Ver anteriores
                </div>)}
                {messagesToShow.map ((message) => (
                    <MessageBubble
                        key={message.id || message.date}
                        message={Utils.converter.makeHtml(message.text)}
                        read={message.read}
                        date={message.date}
                        iconPath={iconPath}
                    />
                ))}
            </div>
        </div>
    );
}
